import styled from 'styled-components';

export const WithdrawalRequestSentStyled = styled.div`
    h4 {
        margin-top: 12px;
        font-size: 20px;
        font-weight: 600;
        margin-bottom: 0;
    }
    
    p {
        margin-bottom: 0;
    }
    
    .content {
        margin-top: 16px;
        font-size: 16px;
    }
    
    .description {
        margin-top: 6px;
        color: var(--color-white-60);
        font-size: 14px;
    }
    .btn-outline {
        color: var(--color-white-60);
    }
`;

export const WithdrawalRequestSentIconWrapperStyled = styled.div`
    display: flex;
    justify-content: center;
    font-size: 38px;
    
    svg {
        fill: var(--color-white-60);
    }
`;

export const WithdrawalRequestSentButtonsContainerStyled = styled.div`
    display: flex;
    gap: 8px;
    flex-direction: column;
    margin-top: 28px;
`;
